
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#2A333D"}},[_c('path',{attrs:{"d":"M13.482 13.74a6.007 6.007 0 000-8.486 6.006 6.006 0 00-8.485 0l2.128 2.128-5.625.625.625-5.625 2.872 2.872-1.06-1.062c2.923-2.923 7.681-2.923 10.606 0 2.924 2.925 2.924 7.683 0 10.608a7.479 7.479 0 01-5.304 2.193A7.477 7.477 0 013.936 14.8l1.06-1.06a6.007 6.007 0 008.486 0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.077 5.825v3.418l2.553 1.987-.845 1.086-3.085-2.4V5.826h1.377z"}})])])
          )
        }
      }
    